module.exports = __webpack_public_path__ + "static/media/tankSymbology8.0b2532c6.svg";